import { Box } from "@mui/material";
import React from "react";
import Consumables from "./Consumables";

const ConsumablesPage = () => {
  return (
    <Box>
      <Consumables />
    </Box>
  );
};

export default ConsumablesPage;
